export default __webpack_public_path__ + "static/media/trama-azul.2f34b797.png";